import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  UncontrolledPopover,
  PopoverBody,
} from "reactstrap";
import classnames from "classnames";
import { useCurrentUser } from "../../slices/auth/hooks";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import Loading from "../../Components/Loading";
import InfoEmployeeModal from "../../Components/modals/EmployeesModal/InfoEmployeeModal";
import EditEmployeeModal from "../../Components/modals/EmployeesModal/EditEmployeeModal";
import AddEmployeesModal from "../../Components/modals/EmployeesModal/AddEmployee/AddEmployeesModal";
import { getRolesForTables } from "../../slices/admin/thunk";
import { DASHBOARD_USER_ROLES } from "../../constants";
import EmployeesTable from "../../Components/Tables/EmployeesTable/EmployeesTable";
import {
  formatDate,
  getNextBillingDate,
  getStatusEmployees,
} from "../../utils/utils";
import NavTabEmployee from "../../Components/Tabs/NavTabEmployee";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";

import employeesIcon from "../../assets/images/iconsRoles/employeesIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";

const DashboardUsers = () => {
  const inputRef = useRef(null);

  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1");

  const [openModalAddEmployee, setOpenModalAddEmploye] = useState(false);

  const [isTerminated, setIsTerminated] = useState(false);

  const [isPending, setIsPending] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [infoEmployee, setInfoEmployee] = useState(null);

  const [loading, setLoading] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [countByStatus, setCountByStatus] = useState({
    active: 0,
    terminated: 0,
    pending: 0,
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const statusEmployees = getStatusEmployees(isTerminated, isPending);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: DASHBOARD_USER_ROLES.EMPLOYER,
          role: "employees",
          status: statusEmployees,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployees(response.data);
      setTotalEmployees(response.total);
      setCountByStatus({
        active: response.countByStatus?.active,
        terminated: response.countByStatus?.terminated,
        pending: response.countByStatus?.pending,
      });
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchEmployees();
  }, [
    isTerminated,
    isPending,
    currentPage,
    debouncedSearchTerm,
    dispatch,
    currentUser.id,
  ]);

  const handleModalInfo = (item) => {
    setOpenModalInfo(!openModalInfo);
    setInfoEmployee(item);
  };

  const handleModalAddEmployee = () => {
    setOpenModalAddEmploye(true);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const hanldeRefreshTable = async () => {
    await fetchEmployees();
    setActiveTab("3");
    setIsPending(true);
  };

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  const employeeLabel = (
    <label htmlFor="like-input" className="form-label fw-semibold fs-6">
      <div>
        {currentUser.inviteCode && (
          <span className="fs-15 text-muted fw-normal">
            My Employer Code:{" "}
            <span className="text-dark">{currentUser.inviteCode}</span>
          </span>
        )}
      </div>
      {currentUser.coverageEffectiveDate && (
        <span className="fs-15 text-muted fw-normal">
          Next Coverage Effective Date:{" "}
          <span className="text-dark">
            {formatDate(currentUser.coverageEffectiveDate)}
          </span>
          <Button
            className="btn btn-xs py-0 px-1 btn-soft-primary border-primary rounded mx-2"
            id="nextCoverageDate"
          >
            Info
          </Button>
          <UncontrolledPopover
            trigger="hover"
            placement="right"
            target="nextCoverageDate"
          >
            <PopoverBody className="shadow-lg ">
              The date that your employees in the “Active Next Effective Date”
              status will be active on.
            </PopoverBody>
          </UncontrolledPopover>
        </span>
      )}

      <div>
        <span className="fs-15 text-muted  fw-normal d-flex align-items-center">
          Next Billing Date:{" "}
          <span className="text-dark mr-2">{getNextBillingDate()} </span>
          {/* <i
            id="billingDate"
            className="ri-information-fill cursor-pointer text-muted ms-1 fs-4"
          ></i> */}
          <Button
            className="btn btn-xs py-0 px-1 btn-soft-primary border-primary rounded mx-2"
            id="billingDate"
          >
            Info
          </Button>
          <UncontrolledPopover
            trigger="hover"
            placement="right"
            target="billingDate"
          >
            <PopoverBody className="shadow-lg ">
              You can add or terminate employees until the specified time. At
              that time, an invoice will be sent to you with the current
              employees added, to be make them active the next month. Any new
              employees or terminations after that date will be effective for
              the following month.
            </PopoverBody>
          </UncontrolledPopover>
        </span>
      </div>
    </label>
  );

  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      <AddEmployeesModal
        open={openModalAddEmployee}
        setOpen={setOpenModalAddEmploye}
        onCreate={hanldeRefreshTable}
        setEmployees={setEmployees}
        setLoading={setLoading}
      />

      {openModalInfo && (
        <InfoEmployeeModal
          open={openModalInfo}
          setOpen={setOpenModalInfo}
          item={infoEmployee.appUserInfo}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Employees"}
            icon={employeesIcon}
            svg={true}
            text={employeeLabel}
          />

          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex flex-column align-items-start justify-content-start">
                {/* <h1>
                  <i className="bx bx-group text-primary border rounded me-2"></i>
                  Employees
                </h1> */}
              </div>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />
                </div>
              </div>

              <Col xl={12}>
                <div className="d-flex  justify-content-between align-items-center mb-1">
                  <NavTabEmployee
                    loading={loading}
                    toggleTab={toggleTab}
                    activeTab={activeTab}
                    countByStatus={countByStatus}
                  />{" "}
                  <div className="pb-1">
                    <Button
                      onClick={handleModalAddEmployee}
                      color="soft-primary"
                      size="md"
                      className="py-0 d-flex align-items-center border border-primary"
                    >
                      <i className="mdi mdi-plus fs-3 p-0 me-3"></i> Add Employee
                    </Button>
                  </div>
                </div>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployeesTable
                        activeTab={activeTab}
                        data={employees}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        openModalAddEmployee={handleModalAddEmployee}
                        onRefreshTable={hanldeRefreshTable}
                        onEditClick={handleEditClick}
                        paginationProps={{
                          itemsCount: employees.length,
                          totalPages: totalPages,
                          totalItems: totalEmployees,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                        isTerminated={isTerminated}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardUsers;
